import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { InstitusionContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const usePurchaseUsdc1 = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const UsdcAddress = Environment.usdc;
  const tokenAddress = Environment.instituson;
  const contract = InstitusionContract(tokenAddress, web3);

  const purchaseUsdc1 = useCallback(
    async (amount, postApiRes, id, balance, min, stakeIndex) => {
      if (!account) throw new Error("WALLET_NOT_CONNECTED");

      // Format amount
      amount = parseFloat(amount).toFixed(6);
      let roundedAmount = Math.round(amount * 1e12) / 1e12;
      const nd = web3.utils.toWei(roundedAmount.toString(), "mwei");

      // Minimum value for slippage
      let minValue = Math.round(parseFloat(min * 0.99).toFixed(6) * 1e12) / 1e12;
      minValue = web3.utils.toWei(minValue.toString(), "ether");

      try {
        return new Promise(async (resolve, reject) => {
          let gas, gasPrice;

          try {
            gasPrice = parseInt(await web3.eth.getGasPrice()) + 3_000_000_000;
            gas = await contract.methods
              .purchaseWithToken(
                UsdcAddress,
                nd,
                postApiRes.code,
                postApiRes?.normalizationFactor,
                postApiRes.referenceTokenPrice,
                minValue,
                id,
                postApiRes?.price,
                postApiRes.deadline,
                postApiRes?.v,
                postApiRes?.r,
                postApiRes?.s
              )
              .estimateGas({ from: account, gasPrice });
          } catch (err) {
            return reject(err);
          }

          // Send transaction with event listeners
          contract.methods
            .purchaseWithToken(
              UsdcAddress,
              nd,
              postApiRes.code,
              postApiRes?.normalizationFactor,
              postApiRes.referenceTokenPrice,
              minValue,
              id,
              postApiRes?.price,
              postApiRes.deadline,
              postApiRes?.v,
              postApiRes?.r,
              postApiRes?.s
            )
            .send({ from: account, gas, gasPrice })
            .on("transactionHash", (hash) => {
              console.log("USDC1 tx hash:", hash);
            })
            .on("receipt", (receipt) => {
              console.log("USDC1 purchase confirmed:", receipt);
              resolve({ transactionHash: receipt.transactionHash, receipt });
            })
            .on("error", (error) => {
              console.error("USDC1 purchase error:", error);
              reject(error);
            });
        });
      } catch (error) {
        throw error;
      }
    },
    [account, contract, web3]
  );

  return { purchaseUsdc1 };
};

export default usePurchaseUsdc1;

// import { useCallback, useState } from "react";
// import useWeb3 from "../useWeb3";
// import { InstitusionContract} from "../../utils/contractHelpers";
// import { useWeb3React } from "@web3-react/core";
// import Environment from "../../utils/Environment";
// import { toast } from "react-toastify";

// const PurchaseUsdc1 = () => {
//   const { account } = useWeb3React();
//   const web3 = useWeb3();
//   const UsdtAdress=Environment.usdc
//   const priceUsdt=10000
//   const tokenAddress = Environment.instituson;
//   const contract = InstitusionContract(tokenAddress, web3);
//   const purchaseUsdc1 = useCallback(
//     async (amount, postApiRes,id,balance,min,stakeIndex) => {
//       amount =parseFloat(amount).toFixed(6)
//       let amount1 = Math.round((amount) * 1e12) / 1e12;
//       let nd = web3.utils.toWei(amount1.toString(), "mwei");

//       let minvalue=min*0.99
//       minvalue= parseFloat(minvalue).toFixed(6)
//       minvalue=Math.round((minvalue) * 1e12) / 1e12;
//       // console.log(minvalue,'minvalue');
//       minvalue= web3.utils.toWei(minvalue.toString(), "ether");

//       console.log(postApiRes?.factorNormalization,UsdtAdress,priceUsdt.toString(),minvalue,postApiRes.code,id,postApiRes.deadline, postApiRes?.v, postApiRes?.r, postApiRes?.s,' nd,postApiRes.code,id,postApiRes.deadline,postApiRes?.v, postApiRes?.r, postApiRes?.s');
//   //     let tuple = {
//   //       postApiRes.code:postApiRes.postApiRes.code,
//   //       GodAgentPercentage:postApiRes.gotAgentPercentage,
//   //       MegaAgentPercentage:postApiRes.megaAgentPercentage,
//   //       SuperAgentPercentage:postApiRes.superAgentPercentage,
//   //       AgentPercentage:postApiRes.agentPercentage,
//   //       GodAgentAddress:postApiRes.gotAgentAddress,
//   //       MegaAgentAddress:postApiRes.megaAgentAddress,
//   //       SuperAgentAddress:postApiRes.superAgentAddress,
//   //       AgentAddress:postApiRes.agentAddress,
//   // };
//   let gas
//       try {
//         let gasPrice=await web3.eth.getGasPrice()
//         gasPrice = parseInt(gasPrice) + 3000000000
//        gas = await contract.methods
//           .purchaseWithToken(
//             UsdtAdress,nd ,postApiRes.code,postApiRes?.normalizationFactor,postApiRes.referenceTokenPrice,minvalue,id,postApiRes?.price,postApiRes.deadline,postApiRes?.v, postApiRes?.r, postApiRes?.s
//           )
//           .estimateGas({
//             from: account,
//             gasPrice
//           });
//         const details = await contract.methods
//           .purchaseWithToken(
//             UsdtAdress,nd ,postApiRes.code,postApiRes?.normalizationFactor,postApiRes.referenceTokenPrice,minvalue,id,postApiRes?.price,postApiRes.deadline,postApiRes?.v, postApiRes?.r, postApiRes?.s
//           )
//           .send({
//             from: account,
//             gas:gas,
//             gasPrice
//           });
//         return details;
//       } catch (error) {
//         console.log(error,'errorerror');

//         // let gasPrice1=await web3.eth.getGasPrice()
//         // let gasPrice = parseInt(gasPrice1) + 3000000000
//         // gas=gas*gasPrice
//         // let nd = web3.utils.fromWei(gas.toString(), "ether");
//         // console.log(gas,nd,balance );
//         // if(nd>balance){
//         //    toast.error("Insufficient ETH for Transaction")
//         // }else{
//           throw error;
//         // }
 
//       }
//     },
//     [contract, account,web3]
//   );
//   return { purchaseUsdc1: purchaseUsdc1 };
// };
// export default PurchaseUsdc1;
